var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { assertNever } from "../assertNever";
export function formatTokens(parsed) {
    var e_1, _a, e_2, _b;
    var out = [];
    var clrCount = 0;
    var fixCount = 0;
    var format = undefined;
    var color = undefined;
    try {
        for (var parsed_1 = __values(parsed), parsed_1_1 = parsed_1.next(); !parsed_1_1.done; parsed_1_1 = parsed_1.next()) {
            var token = parsed_1_1.value;
            if (token.type === "text") {
                token.text.split(/\r\n|\n/).forEach(function (line, index, arr) {
                    var haveNext = index !== arr.length - 1;
                    out.push({
                        type: "text",
                        text: line,
                        isClr: clrCount > 0 || undefined,
                        isFix: fixCount > 0 || undefined,
                        color: color,
                    });
                    if (haveNext) {
                        out.push({
                            type: "newline",
                            isFix: fixCount > 0 || undefined,
                        });
                    }
                });
            }
            else if (token.type === "format") {
                if (!format && token.format) {
                    format = {
                        format: token.format,
                        startedAt: out.length,
                    };
                }
            }
            else if (token.type === "color") {
                if (!color && token.color) {
                    color = token.color;
                }
            }
            else if (token.type === "tag") {
                var tag = token.tag;
                if (tag === "/color") {
                    color = undefined;
                }
                else if (tag === "/fix") {
                    fixCount--;
                }
                else if (tag === "/format") {
                    if (format) {
                        var length = 0;
                        try {
                            for (var _c = (e_2 = void 0, __values(out.slice(format.startedAt))), _d = _c.next(); !_d.done; _d = _c.next()) {
                                var token_1 = _d.value;
                                length += token_1.type === "text" ? token_1.text.length : 0;
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        var padNeeded = Math.max(0, format.format.numberOfSpaces - length);
                        var leftPad = padNeeded
                            ? format.format.kind === "left"
                                ? new Array(padNeeded).fill(" ").join("")
                                : format.format.kind === "center"
                                    ? new Array(Math.floor(padNeeded / 2)).fill(" ").join("")
                                    : ""
                            : "";
                        var rightPad = padNeeded
                            ? format.format.kind === "right"
                                ? new Array(padNeeded).fill(" ").join("")
                                : format.format.kind === "center"
                                    ? new Array(Math.ceil(padNeeded / 2)).fill(" ").join("")
                                    : ""
                            : "";
                        if (leftPad) {
                            out.splice(format.startedAt, 0, {
                                type: "text",
                                isClr: clrCount > 0 || undefined,
                                isFix: fixCount > 0 || undefined,
                                text: leftPad,
                            });
                        }
                        if (rightPad) {
                            out.push({
                                type: "text",
                                isClr: clrCount > 0 || undefined,
                                isFix: fixCount > 0 || undefined,
                                text: rightPad,
                            });
                        }
                    }
                    format = undefined;
                }
                else if (tag === "clr") {
                    clrCount++;
                }
                else if (tag === "clrEnd" || tag === "/clr") {
                    clrCount--;
                }
                else if (tag === "fix") {
                    fixCount++;
                }
                else {
                    assertNever(tag);
                }
            }
            else {
                assertNever(token);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (parsed_1_1 && !parsed_1_1.done && (_a = parsed_1.return)) _a.call(parsed_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return out;
}
//# sourceMappingURL=data:application/json;base64,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